import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { PageSizes } from "../../../common/constants";
import { EntityObject } from "../../../common/types";
import type { UpdateCalculatedCommissionList } from "../batch/types";
import { SplitCommissionsReport } from "./enums";
import type {
  SplitCommission,
  SplitCommissionsExportRequest,
  SplitCommissionsFilterPageRequest,
  SplitCommissionsFilterPageResult,
  UpdateSplitCommission,
} from "./types";

const FILTER_SPLIT_COMMISSIONS = ApiRequestAdapter.create("/split-commissions", HttpMethod.GET);
const DOWNLOAD_SPLIT_COMMISSIONS_EXPORT = ApiRequestAdapter.create("/split-commissions/export", HttpMethod.GET);
const UPDATE_SPLIT_COMMISSIONS = ApiRequestAdapter.create("/split-commissions/{0}", HttpMethod.PUT);
const UPDATE_SPLIT_CALCLULATED_COMMISSIONS = ApiRequestAdapter.create(
  "/split-commissions/{0}/calculations",
  HttpMethod.PUT,
);

export const splitCommissionsApi = {
  filterSplitCommissions: (
    request: SplitCommissionsFilterPageRequest,
  ): AxiosPromise<SplitCommissionsFilterPageResult> => {
    return apiService.get(FILTER_SPLIT_COMMISSIONS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  downloadSplitCommissionsExport: (request: SplitCommissionsExportRequest): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_SPLIT_COMMISSIONS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
  updateSplitCommissions: (request: EntityObject<UpdateSplitCommission>): AxiosPromise<SplitCommission> => {
    return apiService.put(UPDATE_SPLIT_COMMISSIONS.getParametrizedUrl(request.id), request.object);
  },
  updateSplitCalculatedCommissions: (
    request: EntityObject<UpdateCalculatedCommissionList>,
  ): AxiosPromise<SplitCommission> => {
    return apiService.put(UPDATE_SPLIT_CALCLULATED_COMMISSIONS.getParametrizedUrl(request.id), request.object);
  },
};

export const DEFAULT_SPLIT_COMMISSIONS_QUERY_PARAMS: Required<SplitCommissionsFilterPageRequest> = {
  pageSize: PageSizes.LARGE,
  pageIndex: 0,
  keyword: "",
  orderBy: [],
  orderDirections: [],
  report: SplitCommissionsReport.PLANNED_IN_FINISHED_BATCH,
  institutionIds: [],
  gainerIds: [],
  originalBatchIds: [],
  payoutBatchIds: [],
};
